// Canonical formatter for AGGREGATE hour metrics across the dashboard —
// "27h 4m", "45m", "3h", "0m". Use this everywhere hours/minutes totals are
// shown so every page reads identically (per-clip mm:ss timers are separate).
export function formatHm(seconds: number): string {
  if (!seconds || seconds <= 0) return '0m';
  const totalMinutes = Math.floor(seconds / 60);
  if (totalMinutes < 60) return `${totalMinutes}m`;
  const h = Math.floor(totalMinutes / 60);
  const m = totalMinutes % 60;
  return m > 0 ? `${h}h ${m}m` : `${h}h`;
}
